var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path, _rect1, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TEMPLATE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M96,0v96H0V0H96 M97-1h-1H0h-1v1v96v1h1h96h1v-1V0V-1L97-1z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A6D",
    d: "M90,6v84H6V6H90 M96,0H0v96h96V0L96,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "78,88 18,88 18,8 60,8 78,26  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M60.001,6H16v84h64V26L60.001,6z M60,9l17,17H60V9z M78,88H18V8h40v20h20V88z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0078D7",
    d: "M41.041,14l-1.5196,17.8918c-0.079,0.8353-0.1183,1.3856-0.1183,1.6497 c0,0.4231,0.0738,0.7456,0.2213,0.9674c0.1869,0.3068,0.4404,0.5342,0.7602,0.6824c0.3194,0.1481,0.8579,0.2218,1.6154,0.2218 L41.8379,36h-7.879l0.1625-0.5869h0.3393c0.6392,0,1.1605-0.1477,1.5641-0.444c0.285-0.2009,0.5063-0.5338,0.6639-0.9992 c0.1078-0.3277,0.2112-1.0998,0.3097-2.316l0.2359-2.7282h-5.7244l-2.0359,2.9661c-0.4625,0.6663-0.7527,1.1449-0.8706,1.4356 c-0.118,0.2911-0.1771,0.5632-0.1771,0.8168c0,0.3386,0.1277,0.6292,0.3838,0.8724c0.2554,0.2436,0.6785,0.3756,1.2687,0.3965 L29.9165,36H24l0.1621-0.5869c0.7283-0.0318,1.3698-0.2935,1.9255-0.785c0.5557-0.4919,1.3844-1.541,2.4861-3.1485L40.5246,14 H41.041z M38.1198,19.2821l-5.7985,8.4858h5.0313L38.1198,19.2821z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 40,
    fill: "#0078D7",
    width: 48,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    fill: "#C8C8C8",
    width: 24,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 52,
    fill: "#C8C8C8",
    width: 24,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 58,
    fill: "#C8C8C8",
    width: 24,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 64,
    fill: "#C8C8C8",
    width: 48,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 70,
    fill: "#C8C8C8",
    width: 48,
    height: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 76,
    fill: "#C8C8C8",
    width: 48,
    height: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 34,
    fill: "#69AFE5",
    width: 26,
    height: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 28,
    fill: "#69AFE5",
    width: 6,
    height: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 46,
    fill: "#69AFE5",
    width: 20,
    height: 14
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.1734,
    y1: 11.7282,
    x2: 76.9786,
    y2: 92.5353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2264,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    style: {
      stopColor: "#F4F4F4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#E6E6E6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#D1D1D1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6652,
    style: {
      stopColor: "#B7B7B7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9761,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M80,26L60,6H16v84h64V26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 68,
    y1: 33.8125,
    x2: 68,
    y2: 28.175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    style: {
      stopColor: "#7F7F7F",
      stopOpacity: 0.0281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    style: {
      stopColor: "#777777",
      stopOpacity: 0.045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5899,
    style: {
      stopColor: "#696969",
      stopOpacity: 0.059
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    style: {
      stopColor: "#545454",
      stopOpacity: 0.0713
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3A3A3A",
      stopOpacity: 0.0826
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9294,
    style: {
      stopColor: "#1A1A1A",
      stopOpacity: 0.0929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 28,
    fill: "url(#SVGID_2_)",
    width: 20,
    height: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.84,
    y1: 38.16,
    x2: 74.96,
    y2: 21.04
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "16,6 16,8 58,8 58,28 78,28 78,90 80,90 80,26 60,6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdt);
export default __webpack_public_path__ + "static/media/odt.9c0ec2a75e654a5cb8709bf06215e142.svg";
export { ForwardRef as ReactComponent };